
function arrayToStringWithCount(arr) {
    if (arr.length === 0) {
        return '';
    }
    return '[' + arr.length + '] ' + arr.join(', ');
}

export default arrayToStringWithCount;
